/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { SFC } from 'react';
import { routeNode, RouteView } from 'react-mobx-router5';
import routes from '../../routes';
import IBaseRouteViewProps from './IBaseRouteViewProps';


const routeNodeName = '';
const BaseRouteView: SFC<IBaseRouteViewProps> = props => {
  return <RouteView routes={routes} route={props.route} routeNodeName={routeNodeName} routeProps={props} />;
};

export { BaseRouteView };
export default routeNode(routeNodeName)(BaseRouteView);
